const es = {
  // Header
  nav_home: 'Inicio',
  nav_booking: 'Reservar',
  nav_therapists: 'Terapeutas',
  menu_label: 'Menú',

  // Hero
  hero_badge: 'Premium Thai Massage',
  hero_title: 'Experimenta el mejor\nmasaje tailandés',
  hero_subtitle: 'Reserva un masaje premium con terapeutas profesionales en Pattaya, Phuket, Bangkok y Korat',
  hero_book_now: 'Reservar ahora',
  hero_view_therapists: 'Ver terapeutas',
  stat_therapists: 'Terapeutas expertos',
  stat_locations: 'Ubicaciones',
  stat_rating: 'Calificación prom.',

  // Features
  feature_gps_title: 'Detección GPS auto',
  feature_gps_desc: 'Encuentra automáticamente la ubicación más cercana desde tu posición',
  feature_booking_title: 'Reserva fácil',
  feature_booking_desc: 'Reserva un masaje fácilmente en solo 5 pasos',
  feature_verified_title: 'Terapeutas verificados',
  feature_verified_desc: 'Terapeutas profesionales verificados por experiencia y reseñas',

  // Nearby therapists section
  nearby_title: 'Terapeutas cerca de ti',
  nearby_subtitle: 'Terapeutas recomendados según tu ubicación GPS',
  nearby_loading: 'Detectando tu ubicación...',
  nearby_error: 'No se pudo detectar tu ubicación',
  nearby_retry: 'Reintentar',
  nearby_distance: 'A {distance} km',
  nearby_book: 'Reservar ahora',

  // Locations section
  section_locations_title: 'Ubicaciones disponibles',
  section_locations_subtitle: 'Ofrecemos servicios en 5 ciudades principales de Tailandia',
  loc_book: 'Reservar',

  // Courses section
  section_courses_title: 'Cursos de masaje',
  section_courses_subtitle: 'Descubre nuestros diversos programas de masaje',

  // Therapists section
  section_therapists_title: 'Terapeutas populares',
  section_therapists_subtitle: 'Conoce a nuestros terapeutas mejor calificados',
  view_all_therapists: 'Ver todos los terapeutas',

  // CTA
  cta_title: 'Reserva ahora',
  cta_subtitle: 'La mejor experiencia de masaje tailandés te espera',
  cta_book: 'Reservar',

  // Footer
  footer_copyright: '© 2026 Thai Massage Booking. Todos los derechos reservados.',

  // Booking Steps
  step_location: 'Ubicación',
  step_course: 'Curso',
  step_therapist: 'Terapeuta',
  step_datetime: 'Fecha/Hora',
  step_confirm: 'Confirmar',

  // Booking - Step 1
  booking_location_title: 'Selecciona una ubicación',
  booking_location_desc: 'Elige el área donde deseas tu masaje',
  gps_detect: 'Detectar mi ubicación',
  gps_loading: 'Detectando ubicación...',

  // Booking - Step 2
  booking_course_title: 'Selecciona un curso de masaje',
  booking_course_desc: 'Elige tu tipo de masaje y duración preferidos',
  duration_min: '{min} min',

  // Booking - Step 3
  booking_therapist_title: 'Selecciona un terapeuta',
  booking_therapist_desc: 'Terapeutas disponibles en {location}',
  no_therapist: 'No hay terapeutas disponibles para la ubicación y curso seleccionados.',
  no_therapist_suggest: 'Por favor, prueba con otro curso.',

  // Booking - Step 4
  booking_datetime_title: 'Selecciona fecha y hora',
  booking_datetime_desc: 'Elige tu fecha y hora preferidas',
  date_select: 'Seleccionar fecha',
  time_select: 'Seleccionar hora',
  time_placeholder: 'Por favor, selecciona primero una fecha',
  time_notice: 'El terapeuta puede tardar hasta 2 horas en llegar según la distancia. Por favor, elige un horario con suficiente margen.',

  // Booking - Step 5
  booking_confirm_title: 'Confirma tu reserva',
  booking_confirm_desc: 'Revisa toda la información e ingresa tus datos de contacto',
  summary_location: 'Ubicación',
  summary_course: 'Curso',
  summary_price: 'Precio',
  summary_therapist: 'Terapeuta',
  summary_date: 'Fecha',
  summary_time: 'Hora',
  health_check_title: 'Estado de salud',
  health_check_desc: 'Infórmenos si tiene alguna condición de salud, dolor o zonas que desee evitar durante el masaje.',
  health_check_placeholder: 'Ej: Tengo presión arterial alta / Mi hombro derecho está lesionado, por favor sea suave en la parte superior / Evite la espalda baja por hernia de disco',
  health_check_examples: 'Ej: Tengo presión arterial alta / Mi hombro derecho está lesionado, por favor sea suave en la parte superior / Evite la espalda baja por hernia de disco',
  contact_title: 'Información de contacto',
  contact_name: 'Nombre',
  contact_name_placeholder: 'Ingresa tu nombre',
  contact_phone: 'Teléfono',
  contact_phone_placeholder: 'Ingresa tu número de teléfono',
  contact_email: 'Correo electrónico',
  contact_email_placeholder: 'Ingresa tu correo electrónico',
  contact_note: 'Solicitudes especiales',
  contact_note_placeholder: 'Ingresa cualquier solicitud especial',
  required_mark: '*',

  // Navigation buttons
  btn_prev: 'Atrás',
  btn_next: 'Siguiente',
  btn_complete: 'Completar reserva',

  // Therapist card
  age_suffix: ' años',
  experience_years: '{years} años exp.',

  // Therapist list page
  tl_title: 'Terapeutas',
  tl_subtitle: 'Conoce a nuestros mejores terapeutas verificados por experiencia y especialización',
  tab_all: 'Todos',

  // Confirmation page
  conf_empty_title: 'Sin información de reserva',
  conf_empty_desc: 'Por favor, realiza una reserva desde la página de reservas.',
  conf_empty_btn: 'Reservar',
  conf_success_title: '¡Reserva confirmada!',
  conf_success_subtitle: 'Tu reserva ha sido confirmada. Gracias.',
  conf_preparation_title: 'Reserva no recibida',
  conf_preparation_subtitle: 'Nuestro servicio está en preparación, por lo que tu reserva aún no está confirmada. Te contactaremos una vez que el servicio esté disponible.',
  conf_preparation_notice: 'El servicio está en preparación: esta reserva no es una reserva confirmada.',
  conf_booking_id: 'N° de reserva',
  conf_detail_title: 'Detalles de la reserva',
  conf_label_location: 'Ubicación',
  conf_label_course: 'Curso de masaje',
  conf_label_price: 'Precio',
  conf_label_therapist: 'Terapeuta',
  conf_label_date: 'Fecha',
  conf_label_time: 'Hora',
  conf_label_email: 'Correo electrónico',
  conf_label_contact: 'Contacto',
  conf_label_note: 'Solicitudes especiales',
  conf_notice_title: 'Aviso importante',
  conf_notice_1: 'El terapeuta puede tardar hasta 2 horas en llegar según la distancia.',
  conf_notice_2: 'Contáctenos por teléfono para cambios o cancelaciones de reserva.',
  conf_notice_3: 'El pago se puede realizar en el lugar en efectivo o con tarjeta.',
  conf_btn_home: 'Inicio',
  conf_btn_new: 'Nueva reserva',

  // Geolocation errors
  GEO_NOT_SUPPORTED: 'Tu navegador no soporta GPS.',
  GEO_PERMISSION_DENIED: 'Se denegó el acceso a la ubicación. Por favor, selecciona una ubicación manualmente.',
  GEO_POSITION_UNAVAILABLE: 'La información de ubicación no está disponible.',
  GEO_TIMEOUT: 'La solicitud de ubicación ha expirado.',
  GEO_UNKNOWN: 'Ocurrió un error desconocido.',

  // SEO
  seo_home_title: 'Masaje a Domicilio en Tailandia | Bangkok In Home Massage',
  seo_home_desc: 'Terapeutas certificados visitan su hotel en Bangkok, Pattaya, Phuket, Chiang Mai y Korat. Masaje tailandés, aromaterapia y aceite. Reserve en línea fácilmente.',
  seo_therapists_title: 'Terapeutas de Masaje a Domicilio | Bangkok In Home Massage',
  seo_therapists_desc: 'Terapeutas certificados en Bangkok, Pattaya, Phuket, Chiang Mai y Korat. Vea perfiles, calificaciones y especialidades, y reserve en línea al instante.',
  seo_booking_title: 'Reservar Masaje a Domicilio | Bangkok In Home Massage',
  seo_booking_desc: 'Seleccione ubicación, tipo de masaje y terapeuta para reservar un masaje a domicilio. Nuestros terapeutas visitan su hotel o alojamiento.',

  // Body info
  height_label: 'Altura',
  weight_label: 'Peso',

  // GPS therapist list
  gps_find_nearby: 'Buscar terapeutas cercanos',
  gps_nearby_active: 'Ordenado por cercanía',

  // Notices
  notice_punctual: 'El terapeuta llegará en la fecha y hora reservadas. Por favor, esté listo a tiempo.',
  notice_no_sexual: 'Este es un servicio de masaje profesional. Los servicios sexuales están estrictamente prohibidos.',

  // Guide section
  guide_title: 'Guía del servicio',
  guide_subtitle: 'Lea la siguiente información para una experiencia cómoda',
  guide_before_title: 'Antes de la sesión',
  guide_before_text: 'Se recomienda una ducha ligera antes de la sesión. Evite programar inmediatamente después de comer. El servicio puede ser rechazado en estado de embriaguez. Si tiene condiciones médicas (hipertensión, enfermedades cardíacas, etc.) o está embarazada, indíquelo en las solicitudes especiales al reservar.',
  guide_booking_title: 'Info de reserva',
  guide_booking_text: 'El terapeuta puede tardar hasta 2 horas en llegar según la distancia. Elija un horario con suficiente margen. Para cambios o cancelaciones, contáctenos por teléfono.',
  guide_session_title: 'Durante la sesión',
  guide_session_text: 'El terapeuta visitará su alojamiento a la hora reservada. Si siente alguna molestia durante la sesión, informe al terapeuta de inmediato. Este es un servicio de masaje profesional. Los servicios sexuales están estrictamente prohibidos.',
  guide_after_title: 'Después de la sesión',
  guide_after_text: 'Beba abundante agua. El dolor muscular temporal o la fatiga son normales y se resolverán en 2-3 días. Evite el consumo excesivo de alcohol y el ejercicio intenso el día de la sesión.',
  guide_payment_title: 'Pago',
  guide_payment_text: 'El pago se puede realizar en el lugar en efectivo o con tarjeta.',

  // FAQ
  faq_q1: '¿Cómo funciona el masaje a domicilio?',
  faq_a1: 'Seleccione su ubicación, elija un tipo de masaje, un terapeuta y reserve fecha y hora. El terapeuta irá a su hotel o alojamiento.',
  faq_q2: '¿En qué áreas ofrecen servicio?',
  faq_a2: 'Ofrecemos servicios profesionales de masaje a domicilio en Bangkok, Pattaya, Phuket, Chiang Mai y Korat.',
  faq_q3: '¿Cómo puedo cambiar o cancelar mi reserva?',
  faq_a3: 'Contáctenos por teléfono para cambios o cancelaciones. El pago se puede realizar en el lugar en efectivo o con tarjeta.',

  // 404
  notfound_title: 'Página no encontrada',
  notfound_desc: 'La página solicitada no existe o ha sido movida.',
  notfound_home: 'Ir al inicio',
};

export default es;
